// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a41fc806","239":"d1f5f106","453":"2b3c5bd8","667":"f225df13"}[chunkId] + ".chunk.js";
};